import React from 'react';

import {AppFlags} from '../../../app/app-types';
import {connectAppEnv} from '../../../app/app-env';
import {UIControllerType} from '../../../react-oe/oe-types';
import {withIsOpenState, frefFromRef, frefToRef} from '../../../lib/react/higher-order-components';
import {withUILevel} from '../../../lib/react/oe-higher-order-components';
import {OEViewType} from '../../../lib/oe-types';
import OENotification from '../../../lib/notification/oe-notification';
import OEPopover from '../../views/oe-popover';
import OESettingsController from './oe-settings-controller';
import {OESettingsControllerProps} from './oe-settings-model';
import {OEManualViewLinks} from '../../views/manual-view/oe-manual-view-model';
import {OEDefaultConfigFactory} from '../../oe-default-configs';

export class OESettingsControllerPopover extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onModelStateUpdateDriverRef = this.onModelStateUpdateDriverRef.bind(this);

        this.onIsOpenStateChanged = this.onIsOpenStateChanged.bind(this);
        this.onHelpBtnPressed = this.onHelpBtnPressed.bind(this);
    }

    onModelStateUpdateDriverRef(ref)    {
        this.modelStateUpdateDriver = ref;
    }

    render() {
        if(!this.props.config.enabled) return null;

        const {className, uiControllerType, target, placement, hideArrow, noHeader, offset, isOpen, icon, title, titleId, ...rest} = this.props;
        
        return (
            <OEPopover 
                className={'popover-control ' + className}
                moduleId={this.props.moduleId}
                uiControllerType={uiControllerType}
                target={target}
                placement={placement}
                boundariesElement={this.props.boundariesElement}
                hideArrow={hideArrow}
                noHeader={noHeader}
                offset={offset}
                buttonClassName="transparent-btn"
                isOpen={isOpen}
                icon={icon}
                title={title}
                titleId={titleId}
                onIsOpenStateChanged={this.onIsOpenStateChanged}
                onHelpBtnPressed={this.props.config.showHelpBtn ? this.onHelpBtnPressed : null}
            >
                <OESettingsController {...rest} onModelStateUpdateDriverRef={this.onModelStateUpdateDriverRef}/>
            </OEPopover>
        );
    }

    onIsOpenStateChanged(sender, isOpen)  {
        if(!this.modelStateUpdateDriver)    return;
        if(!isOpen) {
            this.modelStateUpdateDriver.updateAppliedDisabled(false);
        } else {
            this.modelStateUpdateDriver.updateAppliedDisabled();
        }
    }

    onHelpBtnPressed()  {
        if(this.props.appComponent)    this.props.appComponent.uiLayer.manualView.setOpen(true, {link: OEManualViewLinks.settings});
    }
}

OESettingsControllerPopover.defaultProps = OESettingsControllerProps.popoverDefaultProps;

OESettingsControllerPopover.propTypes = OESettingsControllerProps.popover;

//
export default connectAppEnv((env) => {
    const ui = env.config.module.uiLayerConfig;
    return {
        appComponent:       env.component,
        uiControllerType:   UIControllerType.settings,
        placement:          'right-start',
        titleId:            'settings_view',
        config:             OEDefaultConfigFactory.combineShowHelpState(ui.widgetConfig.settingsController, ui.widgetConfig.showHelp, ui.manualView.links, OEManualViewLinks.settings),
        devFeatures:        env.config.module.flags && env.config.module.flags.includes(AppFlags.import)
    }
})(withUILevel(OESettingsControllerPopover));

//
export const OESecondarySettingsControllerPopover = frefFromRef(connectAppEnv((env) => {
    const ui = env.config.module.uiLayerConfig;
    return {
        appComponent:       env.component,
        className:          'secondary-settings',
        placement:          'top',
        hideArrow:          true,
        noHeader:           true,
        config:             ui.widgetConfig.secondarySettingsController,
        devFeatures:        env.config.module.flags && env.config.module.flags.includes(AppFlags.import)
    }
})(withUILevel(frefToRef(withIsOpenState(OESettingsControllerPopover, (sender, isOpen) => {
        let appComponent = sender.props.appComponent;
        if(!appComponent || !appComponent.uiLayer) return;
        appComponent.uiLayer.notificationCenter.post(OENotification.viewOpenStateChanged, {
            type:           OEViewType.secondarySettings,
            isOpen:         isOpen,
            sender:         sender
        });
    })))
));